import {getRawMaterialList} from "@/api/RawMaterial"

export default {
  addRawMaterial({ commit }, rawMaterial) {
    return new Promise((resolve, reject) => {
      commit('ADD_RAW_MATERIAL', rawMaterial)
          resolve()
        .catch((error) => { reject(error) })
    })
  },
  fetchDataListItemsRawMaterial({ commit },payload) {
    return new Promise((resolve, reject) => {
      getRawMaterialList(payload)
      .then((response) => {
        if(response.status === 200){
        commit('SET_RAW_MATERIALS', response.data);
        resolve(response);
        }else{
          reject(new Error("Listeleme İşlemi Başarısız ! " + response.status));
        }
      })
      .catch(error => {
        reject(new Error("Sunucu Bağlantısı Başarısız !"));
      })
    })
  },
  updateRawMaterial({ commit }, rawMaterial) {
    return new Promise((resolve, reject) => {
      commit('UPDATE_RAW_MATERIAL', rawMaterial)
          resolve()
        .catch((error) => { reject(error) })
    })
  },
  removeRawMaterial({ commit }, rawMaterialId) {
    return new Promise((resolve, reject) => {
      commit('REMOVE_RAW_MATERIAL', rawMaterialId)
          resolve();
    })
  }
};